import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Container,
  Alert,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import api from '../api';
import { appNameWithVersion } from '../version';
import { useLanguage } from '../context/LanguageContext';

const ForgotPassword = ({ onBackToLogin }) => {
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const result = await api.forgotPassword(email.trim());
      if (result.success) {
        setSuccess(result.message);
      } else {
        setError(result.message || 'Failed to send reset email');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper
        elevation={3}
        sx={{
          mt: 8,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src="/salinator-logo.png"
          alt="Salinator Logo"
          sx={{ maxWidth: '154px', width: '70%', mb: 2 }}
        />

        <Typography variant="h6" component="h2" color="primary" sx={{ mb: 1, fontWeight: 'bold' }}>
          {appNameWithVersion}
        </Typography>

        <Typography component="h1" variant="h5" sx={{ mb: 1 }}>
          {language === 'nl' ? 'Wachtwoord vergeten' : 'Forgot Password'}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
          {language === 'nl'
            ? 'Voer je e-mailadres in en we sturen je een resetlink.'
            : 'Enter your email address and we will send you a reset link.'}
        </Typography>

        {error && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
            {success}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label={language === 'nl' ? 'E-mailadres' : 'Email Address'}
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading || Boolean(success)}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading || Boolean(success)}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : language === 'nl' ? (
              'Verstuur resetlink'
            ) : (
              'Send Reset Link'
            )}
          </Button>
        </Box>

        <Button
          startIcon={<ArrowBackIcon />}
          onClick={onBackToLogin}
          sx={{ mt: 1 }}
        >
          {language === 'nl' ? 'Terug naar inloggen' : 'Back to Sign In'}
        </Button>
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
